import { render } from "./weekTestNum.vue?vue&type=template&id=4578d7ca&scoped=true"
import script from "./weekTestNum.vue?vue&type=script&lang=js"
export * from "./weekTestNum.vue?vue&type=script&lang=js"

import "./weekTestNum.vue?vue&type=style&index=0&id=4578d7ca&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4578d7ca"]])

export default __exports__